export default function script_widowOpen() {
  jQuery(function($){
  
    // news全てを表示する    
    $("#newsbox #over_on span").on('click', function() {
      if($("#newsbox ul").height() != 500) {
        $("#newsbox ul").animate({'height': '500px'},{'duration': 200,'easing': 'swing','complete':function() {
                $("#newsbox #over_on span").html("…全てを表示する▼");
              }});        
      } else {
        var hei =0;
        $("#newsbox li").each(function() {
          hei = hei+$(this).outerHeight(true);
        });
        if(hei >= 500) {
            $("#newsbox ul").animate({'height': hei},{'duration': 400,'easing': 'swing','complete':function() {
                $("#newsbox #over_on span").html("元に戻す▲");
              }});
            }
          }
        });
      });
}
